import { createDiv, createPara, createSVG } from "../utils/utils";
import { collection, addDoc, getDocs, query, orderBy} from "firebase/firestore";
import { db } from "../firebase.js";
import { auth } from "../firebase"; 
import clickedTask from "./clickedTaskDetails.js";
import { clickedTaskDetails } from "./clickedTaskDetails.js";
export default function mainContent(){
    const root = document.querySelector(".container");
    const getMain = createDiv(root,"main");
    const darkModeButton = document.querySelector(".sidebar-setting");

    // Creating header
    const getHeader = createDiv(getMain,"header");
    const getHeaderTitleCount = createDiv(getHeader,"header-title-count");
    createPara(getHeaderTitleCount,"header-title","Today");
    const getHeaderCountDiv = createDiv(getHeaderTitleCount,"header-count");
    const myMenu = createSVG(getHeader,"show-sidebar","M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z");
    createPara(getHeaderCountDiv,"header-count-text","0");

    countingUserTasks();

    // -------

    // Creating main content
    const getCreateTask = createDiv(getMain,"create-new-task");
    const getNewTaskSvg = createSVG(getCreateTask,"new-task-svg","M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z");
    createPara(getCreateTask,"new-task-text","Add New Task");
    
    darkModeButton.addEventListener("click",()=>{
        myMenu.classList.toggle("dark-mode-svg-fill");
        getMain.classList.toggle("dark-mode-font-bright");
        getNewTaskSvg.classList.toggle("dark-mode-svg-fill");
    });

    createDiv(getMain,"all-user-tasks"); // Main div holding all the tasks added by the user

    const getSidebarHighTaskList = document.querySelector(".sidebar-high-tasks");
    const getSidebarNormalTaskList = document.querySelector(".sidebar-normal-tasks");
    const getSidebarLowTaskList = document.querySelector(".sidebar-low-tasks");
    const getSidebarTodayTask = document.querySelector(".sidebar-today-tasks");
    const getSidebarUpcomingTask = document.querySelector(".sidebar-upcoming-tasks");
    const getSidebarPastTask = document.querySelector(".sidebar-past-tasks");

    let task = "today";
    fetchUserTasks(task); //By default fetching the task dated today
    clickedTask();
 // Initializing the clickedTaskMain div from clickedTaskdetails.js
    nightModeOnClickedTask()
    // Fetching respective tasks based on user input
        getSidebarHighTaskList.addEventListener("click",()=>{
            task = "high";
            fetchUserTasks(task);
            getCreateTask.style.display = "flex";
        })
        getSidebarNormalTaskList.addEventListener("click",()=>{
            task = "medium";
            fetchUserTasks(task);
            getCreateTask.style.display = "flex";
        })
        getSidebarLowTaskList.addEventListener("click",()=>{
            task = "low";
            fetchUserTasks(task);
            getCreateTask.style.display = "flex";
        })
        getSidebarTodayTask.addEventListener("click",()=>{
            task = "today";
            fetchUserTasks(task);
            getCreateTask.style.display = "flex";
        })
        getSidebarUpcomingTask.addEventListener("click",()=>{
            task = "upcoming";
            fetchUserTasks(task);
            getCreateTask.style.display = "flex";
        })
        getSidebarPastTask.addEventListener("click",()=>{
            task = "past";
            fetchUserTasks(task);
            getCreateTask.style.display = "none";
        })
    // -----------------------------------------

    // Handling the sidebar visiblity from here
        const getSidebar = document.querySelector(".sidebar"); 
        const getSidebarMenu = document.querySelector(".sidebar-hamburger-menu-svg");
        handleResize(getSidebar,getMain,myMenu);
        window.addEventListener("resize", handleResize);

        //Clicking the hamburger button on sidebar hides the sidebar and displays the hambuger button on the header of main content.
        getSidebarMenu.addEventListener("click",()=>{
            hide_Sidebar(getSidebar,getMain,myMenu);
        })

        //Clicking the hamburger button on header of main content hides it and displays the sidebar.
        myMenu.addEventListener("click",()=>{
            show_Sidebar(getSidebar,getMain,myMenu);
        }) 
    // --------------------    
}

// This functions automatically hides the sidebar if width is less than 1200px to ensure responsiveness.
function handleResize() {
    const getSidebar = document.querySelector(".sidebar"); 
    const getMain = document.querySelector(".main");
    const myMenu = document.querySelector(".show-sidebar");

    if (window.innerWidth < 1200) {
        hide_Sidebar(getSidebar,getMain,myMenu);

    } else {
        show_Sidebar(getSidebar,getMain,myMenu);
    }
}   

function hide_Sidebar(getSidebar,getMain,myMenu){
    getSidebar.classList.add("quick-hide");
    getMain.classList.add("adjust-sidebar");
    myMenu.classList.add("quick-show");
}

function show_Sidebar(getSidebar,getMain,myMenu){
    getSidebar.classList.remove("quick-hide");
    getMain.classList.remove("adjust-sidebar");
    myMenu.classList.remove("quick-show");
}

// Fetching users tasks from the firestore.
export async function fetchUserTasks(task) {
    const container = document.querySelector(".all-user-tasks");
    const user = auth.currentUser;
    const userId = user.uid;
    const getMain = document.querySelector(".main");
    const today = new Date().toISOString().split("T")[0];


    container.innerHTML = "";
    // It gets all the documents from my collection named "Tasks" from firestore and sort them by ascending order.
    const q = query(collection(db, "Tasks"), orderBy("createdAt", "asc"));
    const querySnapshot = await getDocs(q);
        
    // Saving all the fetched data into an array.
    const userTasks = [];
    querySnapshot.forEach((doc) => {
        if(userId == doc.data().userId){
            if(task=="high"){
                if(doc.data().priority == "high"){
                    userTasks.push({ id: doc.id, ...doc.data()});
                }
            }
            else if(task=="medium"){
                if(doc.data().priority == "medium"){
                    userTasks.push({ id: doc.id, ...doc.data()});
                }
            }
            else if(task=="low"){
                if(doc.data().priority == "low"){
                    userTasks.push({ id: doc.id, ...doc.data()});
                }
            }
            else if(task=="today"){
                if(doc.data().dueDate == today){
                    userTasks.push({ id: doc.id, ...doc.data()});
                }
            }
            else if(task=="upcoming"){
                if(doc.data().dueDate > today){
                    userTasks.push({ id: doc.id, ...doc.data()});
                }
            }
            else if(task=="past"){
                if(doc.data().dueDate < today){
                    userTasks.push({ id: doc.id, ...doc.data()});
                }
            }
        }
    });
    // Creating a task
    userTasks.forEach(element => {
        const taskHTML = 
        `<div class="user-task" data-id="${element.id}">
            <div class="box-and-title">
                <div class="check-box"></div>
                <p class="task-title">${element.title}</p>
             </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>
        </div> 
        <div class="user-task-h-line"></div> `;
        container.innerHTML += taskHTML;
    });

    fetchClickedTaskDetails(userTasks,getMain);
}
function fetchClickedTaskDetails(userTasks,getMain){
    // Fetching the details of the task clicked by user and passing it to clickedTask.js which shows the details of the clicked task.
    const getAllTask = document.querySelectorAll(".user-task");
    const getNewTaskMain = document.querySelector(".new-task-main");
 
    getAllTask.forEach(task => {
        task.addEventListener("click",()=>{
            getNewTaskMain.classList.remove("quick-show");
            getNewTaskMain.classList.add("quick-hide");
            let getMyTaskId = task.dataset.id;
            let getMyTaskTitle;
            let getMytaskDescription;
            let getMyTaskPriority;
            let getMyTaskDuedate;
            
            userTasks.forEach( myTask => {
                if(getMyTaskId == myTask.id){
                    getMyTaskTitle = myTask.title;
                    getMytaskDescription = myTask.description;
                    getMyTaskPriority = myTask.priority;
                    getMyTaskDuedate = myTask.dueDate;
                }
            });
            clickedTaskDetails(getMyTaskTitle,getMytaskDescription,getMyTaskPriority,getMyTaskDuedate,getMyTaskId);
            const getMyTaskMain = document.querySelector(".clicked-task-main");
            const getCreateNewTask = document.querySelector(".create-new-task");
            getCreateNewTask.addEventListener("click",()=>{
                getMyTaskMain.classList.remove("quick-show");
            })
            getMyTaskMain.classList.add("quick-show");
            getMain.classList.add("adjust-main-right");
        })
    });
}

// Function to count the user task of the respective category eg. today, upcoming, high, low etc
export async function countingUserTasks() {
    const userTasks = [];
    const q = query(collection(db, "Tasks"), orderBy("createdAt", "asc"));
    const querySnapshot = await getDocs(q);
    const user = auth.currentUser;
    const userId = user.uid;

    querySnapshot.forEach((doc) => {
        if(userId == doc.data().userId){
        userTasks.push({ id: doc.id, ...doc.data()});
        }
    });    
            
    let getHighTaskDiv = document.querySelector(".high-count");
    let getMediumTaskDiv = document.querySelector(".normal-count");
    let getLowTaskDiv = document.querySelector(".low-count");
    let getTodayCountDiv = document.querySelector(".today-count");
    let getUpcomingCountDiv = document.querySelector(".upcoming-count");
    let getPastCountDiv = document.querySelector(".past-count");

    let highPriorityCount =0;
    let mediumPriorityCount =0;
    let lowPriorityCount =0;
    let todayTaskCount = 0;
    let upcomingTaskCount = 0;
    let pastTaskCount = 0;

    const today = new Date().toISOString().split("T")[0];

    userTasks.forEach(task => {
        if(task.dueDate == today){
            todayTaskCount++;
        }
        else if(task.dueDate > today){
            upcomingTaskCount++;
        }
        else if(task.dueDate < today){
            pastTaskCount++;
        }
        if(task.priority == "high"){
            highPriorityCount++;
        }
        else if(task.priority == "medium"){
            mediumPriorityCount++;
        }
        else if(task.priority == "low"){
            lowPriorityCount++;
        }
        
    });
    //Setting the count of the each priority task.
    getHighTaskDiv.textContent = highPriorityCount;
    getMediumTaskDiv.textContent = mediumPriorityCount;
    getLowTaskDiv.textContent = lowPriorityCount;
    getTodayCountDiv.textContent = todayTaskCount;
    getUpcomingCountDiv.textContent = upcomingTaskCount;
    getPastCountDiv.textContent = pastTaskCount;

    settingHeaderCountText(highPriorityCount,mediumPriorityCount,lowPriorityCount,todayTaskCount,pastTaskCount,upcomingTaskCount)
}

// Function to display the selected category of task and its count on the header of main content div.
export function settingHeaderCountText(highPriorityCount,mediumPriorityCount,lowPriorityCount,todayTaskCount,pastTaskCount,upcomingTaskCount){
    let getHeaderTitle = document.querySelector(".header-title");
    let getHeaderCount = document.querySelector(".header-count-text");
    const getSidebarHighTaskList = document.querySelector(".sidebar-high-tasks");
    const getSidebarNormalTaskList = document.querySelector(".sidebar-normal-tasks");
    const getSidebarLowTaskList = document.querySelector(".sidebar-low-tasks");
    const getSidebarTodayTask = document.querySelector(".sidebar-today-tasks");
    const getSidebarPastTask = document.querySelector(".sidebar-past-tasks");
    const getSidebarUpcomingTask = document.querySelector(".sidebar-upcoming-tasks");
    
    getHeaderCount.textContent = todayTaskCount;
    getHeaderTitle.textContent = "Today";

    getSidebarHighTaskList.addEventListener("click",()=>{
        getHeaderCount.textContent = highPriorityCount;
        getHeaderTitle.textContent = "High";
    })
    getSidebarNormalTaskList.addEventListener("click",()=>{
        getHeaderCount.textContent = mediumPriorityCount;
        getHeaderTitle.textContent = "Normal";
    })
    getSidebarLowTaskList.addEventListener("click",()=>{
        getHeaderCount.textContent = lowPriorityCount;
        getHeaderTitle.textContent = "Low";
    })
    getSidebarTodayTask.addEventListener("click",()=>{
        getHeaderCount.textContent = todayTaskCount;
        getHeaderTitle.textContent = "Today";
        console.log(getHeaderCount)

    })
    getSidebarPastTask.addEventListener("click",()=>{
        getHeaderCount.textContent = pastTaskCount;
        getHeaderTitle.textContent = "Past";
    })
    getSidebarUpcomingTask.addEventListener("click",()=>{
        getHeaderCount.textContent = upcomingTaskCount;
        getHeaderTitle.textContent = "Upcoming";
    })
}

function nightModeOnClickedTask(){
    const darkModeButton = document.querySelector(".sidebar-setting");
    const getClickedTaskMain = document.querySelector(".clicked-task-main");
    const getMyTaskTitle = document.getElementById("my-task-title");
    const getMyTaskDetail = document.getElementById("my-task-descirption");
    const getCloseMyTask = document.querySelector(".my-task-close-svg");

    const getTaskDueDate = document.querySelector(".my-task-due-date");
    const getDateInput = document.getElementById("date-time-input");


    const getAllLabels = document.querySelectorAll(".clicked-task-main label");
    const getPrioritySelect = document.querySelector(".clicked-task-main select");

    darkModeButton.addEventListener("click", () => {
        getClickedTaskMain.classList.toggle("sidebar-dark-mode");
        getClickedTaskMain.classList.toggle("dark-mode-font-bright");
        getMyTaskTitle.classList.toggle("dark-mode-texfield-color");
        getMyTaskDetail.classList.toggle("dark-mode-texfield-color");
        getCloseMyTask.classList.toggle("dark-mode-svg-fill");

        getPrioritySelect.classList.toggle("dark-mode-texfield-color");
        getAllLabels.forEach(label => label.classList.toggle("dark-mode-font-bright"));
        getTaskDueDate.classList.toggle("dark-mode-font-bright");
        getDateInput.classList.toggle("dark-mode-texfield-color");
      });         
            
}